import React, { useState } from "react";
import { useTable, usePagination } from "react-table";
import SEARCH from "../../../../assets/vw/svg/search.svg";
import before from "../../../../assets/vw/svg/before-mon.svg";
import after from "../../../../assets/vw/svg/after-mon.svg";
import eye from "../../../../assets/vw/svg/eye.svg";
import { buildEstado } from "../../../../utils/estadoCodeBuild";
import { useHistory } from 'react-router-dom';
function Table({
  columns,
  data,
  handleChange,
  handleChangeOrg
}) {
  const [searchInput, setSearchInput] = useState("");
  const [estadoInput, setEstadoInput] = useState("Ok");
  let history = useHistory();
  function searchText(e) {
    setSearchInput(e.target.value);
    handleChange(e);
  }
  function estadoText(e) {
    setEstadoInput(e.target.value);
    handleChangeOrg(e);
  }
  const gridAplicaciones = (page) => {
    return (
      <>
        <div className="monitorapp-container">
          <div
            onClick={() => {
              if (canPreviousPage) {
                previousPage();
              }
            }}
            className={`${!canPreviousPage ? 'disabled' : ''}`}
            style={{ cursor: canPreviousPage ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <img src={before} alt="before"/>
          </div>
          <div className="grid_table">
            {page.map((aplicacion, index) => {
              return (
                <div className="col mb-3 d-flex justify-content-center" key={index} data-track-click={"card-" + aplicacion.original.nombre}>
                  <div className={`card_grid ${aplicacion.original.estado.replace(/\s+/g, '_').toLowerCase()}`}>
                    <div className="information-action">
                      <div className="app">
                        <div className="d-flex"></div>
                        <div className="mx-3 mt-3">
                          <div className="onclick" onClick={() => {
                                history.push(`/vw/especialista/monitoreo?ia=${aplicacion.original.idApp}`);
                            }}>
                            <div className="w-100 flex-row container-title-card">
                              <div className="title_card mb-auto ps-2">
                                {aplicacion.original.nombre}
                              </div>
                              <div className="d-flex flex-column align-items-center">
                                <div className="btn-mon">
                                  <button onClick={() => { history.push(`/vw/especialista/monitoreo?ia=${aplicacion.original.idApp}`)}}>
                                    <img src={eye} alt="eye"/>
                                  </button>
                                </div>
                                <img src={buildEstado(aplicacion.original.build?.status)} alt="build" width={20}/>
                              </div>
                            </div>
                            <div className="url_description mb-auto ps-2">ID app: {aplicacion.original.idApp}</div>
                            {aplicacion.original.ultimoMonitoreo && ( 
                              <div className="url_description mb-auto ps-2">Ultimo monitoreo: {aplicacion.original.ultimoMonitoreo}</div>
                            )}                    
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-row mx-3 mb-1 estado_description">
                      <div className="estado_description mb-0 ps-2">Estado: <div className="estado_description"></div></div>
                      <div className="mb-0 ps-2">{aplicacion.original.estado}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          <div
            onClick={() => canNextPage && nextPage()}
            className={`${!canNextPage ? 'disabled' : ''}`}
            style={{ cursor: canNextPage ? 'pointer' : 'not-allowed', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <img src={after} alt="after"/>
          </div>
        </div>
      </>
    );
  };
  const {
    page,
    canPreviousPage,
    canNextPage,
    nextPage,
    previousPage,
  } = useTable(
      {
        columns,
        data,
        initialState: {pageSize: 12},
      },
      usePagination,
  );
  return(
      <>
        <div className="content main-content-container">
          <div className="main-content-actions row m-0 py-2 px-4">
            <div className="col-6 align-items-center col-sm-6 wrapper m-0 p-0">
              <input
                  className="input_vw"
                  name="searchInput"
                  value={searchInput || ""}
                  onChange={(e) => {
                    searchText(e);
                  }}
                  placeholder="Busca por ID, nombre, URL…"
              />
              <span className="pt-2 ps-1">
              <img src={SEARCH} alt="buscar" className="icono-menu me-3"/>
              </span>
            </div>
            <div className="col-6 d-flex justify-content-end p-0">
                <div className="form-group">
                    <p className="mb-0">Organizar por: </p>
                    <div className="form-check-inline">
                      <input className="form-check-input" type="radio" value="Ok" name="estado" id="estado-ok" onChange={estadoText} checked={estadoInput === 'Ok'}></input>
                      <label className="form-check-label" htmlFor="organizar">Ok</label>
                    </div>
                    <div className="form-check-inline">
                      <input className="form-check-input" type="radio" value="Error" name="estado" id="estado-error" onChange={estadoText} checked={estadoInput === 'Error'}></input>
                      <label className="form-check-label" htmlFor="organizar">Error</label>
                    </div>
                    <div className="form-check-inline">
                      <input className="form-check-input" type="radio" value="Warning" name="estado" id="estado-warning" onChange={estadoText} checked={estadoInput === 'Warning'}></input>
                      <label className="form-check-label" htmlFor="organizar">Warning</label>
                    </div>
                    <div className="form-check-inline">
                      <input className="form-check-input" type="radio" value="Sin monitorear" name="estado" id="estado-sin-monitoreo" onChange={estadoText} checked={estadoInput === 'Sin monitorear'}></input>
                      <label className="form-check-label" htmlFor="organizar">Sin monitorear</label>
                    </div>
                </div>
            </div>
            <div className="row m-0 mb-2 px-4 linea-div"></div>
        </div>
      </div>
      {
        gridAplicaciones(page)
      }
    </>
  );
}
function Tabla(props) {
  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "idApp",
      },
      {
        Header: "Nombre",
        accessor: "nombre",
      },
      {
        Header: "Último monitoreo",
        accessor: "ultimoMonitoreo",
      },
      {
        Header: "Estado",
        accessor: "estado",
      }
    ],
    []
  );
  return (
    <>
      <Table
        columns={columns}
        data={props.aplicaciones}
        servicio={props.servicio}
        marca={props.marca}
        nombreMarca={props.marcaNombre}
        tiposAutenticacion={props.tiposAutenticacion}
        handleChange={props.handleChange}
        handleChangeOrg={props.handleChangeOrg}
      />
    </>
  );
}
export default Tabla;
